import _classCallCheck from "E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _slicedToArray from "E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 *  ShapeInfo.js
 *  @copyright 2002, 2017 Kevin Lindsey
 */

import { Point2D } from "kld-affine";
import { PathParser } from "kld-path-parser";
import PathHandler from "./PathHandler.js";
var degree90 = Math.PI * 0.5;
var parser = new PathParser();

/**
 * getValues
 *
 * @param {Array} types
 * @param {Array} args
 * @returns {Array}
 */
export function getValues(types, args) {
  var result = [];
  var _iterator = _createForOfIteratorHelper(types),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        names = _step$value[0],
        type = _step$value[1];
      var value = null;
      if (type === "Point2D") {
        value = parsePoint(names, args);
      } else if (type === "Number") {
        value = parseNumber(names, args);
      } else if (type === "Array<Point2D>" || type === "Point2D[]") {
        var values = [];
        while (args.length > 0) {
          values.push(parsePoint(names, args));
        }
        if (values.length > 0) {
          value = values;
        }
      } else if (type === "Optional<Number>" || type === "Number?") {
        value = parseNumber(names, args);
        if (value === null) {
          value = undefined;
        }
      } else {
        throw new TypeError("Unrecognized value type: ".concat(type));
      }
      if (value !== null) {
        result.push(value);
      } else {
        throw new TypeError("Unable to extract value for ".concat(names));
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return result;
}

/**
 * parseNumber
 *
 * @param {Array} names
 * @param {Array} args
 * @returns {number}
 */
export function parseNumber(names, args) {
  var result = null;
  if (args.length > 0) {
    var item = args[0];
    var itemType = typeof item;
    if (itemType === "number") {
      return args.shift();
    } else if (itemType === "object") {
      var _iterator2 = _createForOfIteratorHelper(names),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var prop = _step2.value;
          if (prop in item && typeof item[prop] === "number") {
            result = item[prop];
            break;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }
  return result;
}

/**
 * parsePoint
 *
 * @param {Array} names
 * @param {Array} args
 * @returns {Array}
 */
export function parsePoint(names, args) {
  var result = null;
  if (args.length > 0) {
    var item = args[0];
    var itemType = typeof item;
    if (itemType === "number") {
      if (args.length > 1) {
        var x = args.shift();
        var y = args.shift();
        result = new Point2D(x, y);
      }
    } else if (Array.isArray(item) && item.length > 1) {
      if (item.length === 2) {
        var _args$shift = args.shift(),
          _args$shift2 = _slicedToArray(_args$shift, 2),
          _x = _args$shift2[0],
          _y = _args$shift2[1];
        result = new Point2D(_x, _y);
      } else {
        throw new TypeError("Unhandled array of length ".concat(item.length));
      }
    } else if (itemType === "object") {
      if ("x" in item && "y" in item) {
        result = new Point2D(item.x, item.y);
        args.shift();
      } else {
        var _iterator3 = _createForOfIteratorHelper(names),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var props = _step3.value;
            if (Array.isArray(props)) {
              if (props.every(function (p) {
                return p in item;
              })) {
                result = new Point2D(item[props[0]], item[props[1]]);
                break;
              }
            } else if (props in item) {
              result = parsePoint([], [item[props]]);
              break;
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
    }
  }
  return result;
}

/**
 *  ShapeInfo
 *  @memberof module:kld-intersections
 */
var ShapeInfo = /*#__PURE__*/function () {
  /**
   *  @param {string} name
   *  @param {Array} args
   *  @returns {module:kld-intersections.ShapeInfo}
   */
  function ShapeInfo(name, args) {
    _classCallCheck(this, ShapeInfo);
    this.name = name;
    this.args = args;
  }
  _createClass(ShapeInfo, null, [{
    key: "arc",
    value: function arc() {
      var types = [[["center", ["centerX", "centerY"], ["cx", "cy"]], "Point2D"], [["radiusX", "rx"], "Number"], [["radiusY", "ry"], "Number"], [["startRadians"], "Number"], [["endRadians"], "Number"]];
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      var values = getValues(types, args);
      return new ShapeInfo(ShapeInfo.ARC, values);
    }
  }, {
    key: "quadraticBezier",
    value: function quadraticBezier() {
      var types = [[["p1", ["p1x", "p1y"]], "Point2D"], [["p2", ["p2x", "p2y"]], "Point2D"], [["p3", ["p3x", "p3y"]], "Point2D"]];
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      var values = getValues(types, args);
      return new ShapeInfo(ShapeInfo.QUADRATIC_BEZIER, values);
    }
  }, {
    key: "cubicBezier",
    value: function cubicBezier() {
      var types = [[["p1", ["p1x", "p1y"]], "Point2D"], [["p2", ["p2x", "p2y"]], "Point2D"], [["p3", ["p3x", "p3y"]], "Point2D"], [["p4", ["p4x", "p4y"]], "Point2D"]];
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      var values = getValues(types, args);
      return new ShapeInfo(ShapeInfo.CUBIC_BEZIER, values);
    }
  }, {
    key: "circle",
    value: function circle() {
      var types = [[["center", ["centerX", "centerY"], ["cx", "cy"]], "Point2D"], [["radius", "r"], "Number"]];
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      var values = getValues(types, args);
      return new ShapeInfo(ShapeInfo.CIRCLE, values);
    }
  }, {
    key: "ellipse",
    value: function ellipse() {
      var types = [[["center", ["centerX", "centerY"], ["cx", "cy"]], "Point2D"], [["radiusX", "rx"], "Number"], [["radiusY", "ry"], "Number"]];
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }
      var values = getValues(types, args);
      return new ShapeInfo(ShapeInfo.ELLIPSE, values);
    }
  }, {
    key: "line",
    value: function line() {
      var types = [[["p1", ["p1x", "p1y"], ["x1", "y1"]], "Point2D"], [["p2", ["p2x", "p2y"], ["x2", "y2"]], "Point2D"]];
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }
      var values = getValues(types, args);
      return new ShapeInfo(ShapeInfo.LINE, values);
    }
  }, {
    key: "path",
    value: function path() {
      parser.parseData(arguments.length <= 0 ? undefined : arguments[0]);
      return new ShapeInfo(ShapeInfo.PATH, handler.shapes);
    }
  }, {
    key: "polygon",
    value: function polygon() {
      var types = [[[], "Array<Point2D>"]];
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }
      var values = getValues(types, args.length === 1 && Array.isArray(args[0]) ? args[0] : args);
      return new ShapeInfo(ShapeInfo.POLYGON, values);
    }
  }, {
    key: "polyline",
    value: function polyline() {
      var types = [[[], "Array<Point2D>"]];
      for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        args[_key8] = arguments[_key8];
      }
      var values = getValues(types, args.length === 1 && Array.isArray(args[0]) ? args[0] : args);
      return new ShapeInfo(ShapeInfo.POLYLINE, values);
    }
  }, {
    key: "rectangle",
    value: function rectangle() {
      var types = [[["topLeft", ["x", "y"], ["left", "top"]], "Point2D"], [["size", ["width", "height"], ["w", "h"]], "Point2D"], [["radiusX", "rx"], "Optional<Number>"], [["radiusY", "ry"], "Optional<Number>"]];
      for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
        args[_key9] = arguments[_key9];
      }
      var values = getValues(types, args);

      // fix up bottom-right point
      var p1 = values[0];
      var p2 = values[1];
      values[1] = new Point2D(p1.x + p2.x, p1.y + p2.y);

      // create shape info
      var result = new ShapeInfo(ShapeInfo.RECTANGLE, values);

      // handle possible rounded rectangle values
      var ry = result.args.pop();
      var rx = result.args.pop();
      rx = rx === undefined ? 0 : rx;
      ry = ry === undefined ? 0 : ry;
      if (rx === 0 && ry === 0) {
        return result;
      }
      var _result$args$ = result.args[0],
        p1x = _result$args$.x,
        p1y = _result$args$.y;
      var _result$args$2 = result.args[1],
        p2x = _result$args$2.x,
        p2y = _result$args$2.y;
      var width = p2x - p1x;
      var height = p2y - p1y;
      if (rx === 0) {
        rx = ry;
      }
      if (ry === 0) {
        ry = rx;
      }
      if (rx > width * 0.5) {
        rx = width * 0.5;
      }
      if (ry > height * 0.5) {
        ry = height * 0.5;
      }
      var x0 = p1x;
      var y0 = p1y;
      var x1 = p1x + rx;
      var y1 = p1y + ry;
      var x2 = p2x - rx;
      var y2 = p2y - ry;
      var x3 = p2x;
      var y3 = p2y;
      var segments = [ShapeInfo.arc(x1, y1, rx, ry, 2 * degree90, 3 * degree90), ShapeInfo.line(x1, y0, x2, y0), ShapeInfo.arc(x2, y1, rx, ry, 3 * degree90, 4 * degree90), ShapeInfo.line(x3, y1, x3, y2), ShapeInfo.arc(x2, y2, rx, ry, 0, degree90), ShapeInfo.line(x2, y3, x1, y3), ShapeInfo.arc(x1, y2, rx, ry, degree90, 2 * degree90), ShapeInfo.line(x0, y2, x0, y1)];
      return new ShapeInfo(ShapeInfo.PATH, segments);
    }
  }]);
  return ShapeInfo;
}(); // define shape name constants
export { ShapeInfo as default };
ShapeInfo.ARC = "Arc";
ShapeInfo.QUADRATIC_BEZIER = "Bezier2";
ShapeInfo.CUBIC_BEZIER = "Bezier3";
ShapeInfo.CIRCLE = "Circle";
ShapeInfo.ELLIPSE = "Ellipse";
ShapeInfo.LINE = "Line";
ShapeInfo.PATH = "Path";
ShapeInfo.POLYGON = "Polygon";
ShapeInfo.POLYLINE = "Polyline";
ShapeInfo.RECTANGLE = "Rectangle";

// setup path parser handler after ShapeInfo has been defined
var handler = new PathHandler(ShapeInfo);
parser.setHandler(handler);